import {
  buildConsumeStockCommandV1,
  buildInventoryAdjustmentStockCommandV1,
  type StockCommandV1,
} from '@trackeat/shared';

type ExpirationConsumeCommand = Extract<
  StockCommandV1,
  { movement_class: 'consume' }
>;

type ExpirationInventoryAdjustmentCommand = Extract<
  StockCommandV1,
  { movement_class: 'inventory_adjustment' }
>;

export function buildExpirationConsumeCommand(input: {
  commandId: string;
  tenantId: string;
  businessId: string;
  foodId: string;
  lot: string | null;
  expirationDate: string;
  qty: number;
  uom: string;
  reason: 'consumed' | 'waste';
  closeLot: boolean;
}): ExpirationConsumeCommand {
  return buildConsumeStockCommandV1({
    ...input,
    operatorName: null,
    provenance: { supplierId: null, documentId: null, storageUnitId: null },
  });
}

/**
 * A physical count is an inventory fact, not consumption. Keeping the system
 * and counted quantities in the command lets both the local projector and the
 * authoritative RPC materialize the same auditable delta.
 */
export function buildExpirationInventoryAdjustmentCommand(input: {
  commandId: string;
  tenantId: string;
  businessId: string;
  foodId: string;
  lot: string | null;
  expirationDate: string;
  storageUnitId?: string | null;
  systemQty: number;
  countedQty: number;
  uom: string;
  countedAt: string;
  reason?: string;
  operatorName?: string | null;
  unitCost: number | null;
  currency: string;
}): ExpirationInventoryAdjustmentCommand {
  return buildInventoryAdjustmentStockCommandV1({
    ...input,
    reason: input.reason?.trim() || 'inventory_adjustment',
    operatorName: input.operatorName ?? null,
    provenance: {
      supplierId: null,
      documentId: null,
      storageUnitId: input.storageUnitId ?? null,
    },
  });
}
